import styled from 'styled-components';

export default styled.div`
    .unexpected-error {
        color: ${({ theme }) => theme.colors.error};
        font-size: 1rem;
    }
`;
